import { Component, Inject } from '@angular/core';
import { ApplicationStep, providers } from "../nuvei-application-step";
import { DOCUMENT } from "@angular/common";
import { PlacesService } from '../../../../../../common/src/lib/services/places.service';

@Component({
  selector: 'app-nuvei-application-legal',
  templateUrl: './nuvei-application-legal.component.html',
  styleUrls: ['./nuvei-application-legal.component.scss'],
  providers
})
export class NuveiApplicationLegalComponent extends ApplicationStep<'legalForm'> {

  fieldExplanations = [
    { id: 'businessName', title: 'Business Name', explanation: 'The registered legal name of your business.' },
    { id: 'ownershipType', title: 'Ownership Type', explanation: 'The legal structure of your business.\nThis was chosen when registering your business.' },
    { id: 'address', title: 'Address', explanation: 'The physical location of your business.' },
    { id: 'mailingAddress', title: 'Mailing Address', explanation: 'Where you receive official mail.' },
    { id: 'mailingAttention', title: 'Mailing Attention', explanation: 'The person or department who should receive mail.\nUse your name or the name of the responsible party.' },
    { id: 'businessPhoneNumber', title: 'Business Phone Number', explanation: 'The main contact number for your business.' },
    { id: 'supportPhoneNumber', title: 'Support Phone Number', explanation: 'The phone number customers should use for support inquiries.' },
    { id: 'contactPhoneNumber', title: 'Contact Phone Number', explanation: 'A general contact number for communication with vendors and partners.' },
    { id: 'mobilePhoneNumber', title: 'Mobile Phone Number', explanation: 'A mobile number for business-related calls and verification.' },
    { id: 'businessEmail', title: 'Business Email Address', explanation: 'The public-facing email that customers or partners can use to reach your business. This may be the same as the contact email if you don’t have a separate one.' },
    { id: 'contactEmail', title: 'Contact Email Address', explanation: 'The primary email for official business correspondence and account-related notifications.' },
    { id: 'creationDate', title: 'Business Creation', explanation: 'When your business was officially established.\nCheck your business registration documents.' },
    { id: 'federalTaxID', title: 'Federal Tax ID', explanation: 'The Employer Identification Number (EIN) issued by the IRS.\nProvided when registering your business with the IRS.' },
    { id: 'currentPaymentProcessor', title: 'Current payment processor (Optional)', explanation: 'Your existing credit card payment processor (if any).' },
  ];

  fieldToExplanations = {
    'unit': 'address',
    'mailingAddressUnit': 'mailingAddress',
    'creationDatePicker': 'creationDate',
  };

  months = Array.from(Array(12).keys());
  currentYear = (new Date()).getFullYear();

  constructor(
    @Inject(DOCUMENT) protected document: Document,
    protected placesService: PlacesService,
) {
    super();
  }

}
